import { render, staticRenderFns } from "./WorkKind.vue?vue&type=template&id=e9362464"
import script from "./WorkKind.vue?vue&type=script&lang=js"
export * from "./WorkKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports